import React from 'react';
import { Button, Card, Icon, Pdf, Text } from '../../Atoms';
import { Collapse, Input, DetailDocument } from '../../Molecules';
import { useSelector } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
export default function TemplateDocumentGaranties(props) {
  const container = useSelector((state) => state.container);
  function cardClassName(value, list) {
    const classNames = ['type-garanties-doc'];
    if (list.indexOf(value) != -1) {
      classNames.push('type-garanties-doc-selected');
    }
    return classNames.join(' ');
  }
  function templateClassName() {
    const className = [
      'template-document',
      'template-send-document',
      'template-scroll'
    ];
    if (container.padding === false) {
      className.push('mobile-content-nopadding');
    }
    return className.join(' ');
  }
  return (
    <div className={templateClassName()}>
      <div
        className={
          !container.padding
            ? 'content-header-document-garanties container-title-send-doc'
            : 'container-title-send-doc'
        }
      >
        <Text text={'Mes garanties'} className="title-document" />
      </div>
      {props.state.step === 1 && (
        <div className="content-template-type-document">
          <Row>
            {props.state.docList.map((el, index) => (
              <Col xs={12} md={6} className="" key={String(index)}>
                <DetailDocument
                  text={el.name}
                  onViewFile={() => props.onOpen(el)}
                  onDownload={() => props.onDowLoad(el)}
                />
              </Col>
            ))}
          </Row>
        </div>
      )}
      {props.state.step === 2 && (
        <div className="content-template-document-sended">
          <div className="container-doc-sended-step2"></div>
          <Pdf url={props.state.file.url} />
          <div
            className="container-btn-downlond-doc"
            style={{ paddingBottom: '50px' }}
          >
            <Button
              text="Télécharger"
              onClick={() => props.onDowLoad(props.state.documentSelected)}
              className="btn-downlond-doc"
            />
          </div>
        </div>
      )}
    </div>
  );
}
